<template>
  <div>
   
    <i data-icon-name="ChevronLeft" aria-hidden="true" class="ms-Icon root-43"></i>
    {{text}}
  </div>
</template>

<script>
export default {
  name: 'BackNavigation',
  props:["text"],
}
</script>

<style scoped>
div{
  color: white;
  font-family: "Montserrat";
}

div:hover{
  cursor: pointer;
}

i{
  margin-right: 7px;
  font-size: 14px;
}
</style>